<template>
  <b-container fluid class="mt-3 adhoc-reporting-page">
    <b-alert v-if="!hasAccess" show variant="danger">
      Ad-Hoc Reporting is available only for premium organizations where you have reporting access.
    </b-alert>
    <div v-else ref="adhocRoot">
      <h3>Saved Reports</h3>
      <div class="adhoc-panel mb-3">
        <select id="saved-reports" class="form-control d-inline-block w-auto mr-1">
          <option value="">--Choose Saved Report--</option>
        </select>
        <button class="btn btn-white btn-sm" onclick="loadSelectedReport()">Load</button>
        <button class="btn btn-white btn-sm" onclick="runSelectedSavedReport()">Run Saved Report</button>
        <button class="btn btn-white btn-sm" onclick="deleteSelectedSavedReport()">Delete Saved Report</button>
        <button id="new-report-btn" class="btn btn-primary-light btn-sm" onclick="newReport()">New Builder Report</button>
        <span id="saved-report-note" class="preview-note ml-2"></span>
      </div>

      <div id="editor-sections">
        <div class="mb-3">
          <label for="tables" class="font-weight-bold mr-1">Select Tables:</label>
          <select id="tables" class="form-control d-inline-block w-auto">
            <option value="">--Choose Table--</option>
          </select>
          <button class="btn btn-primary-light btn-sm ml-1" onclick="addTable()">Add Table</button>
        </div>

        <h3>Selected Tables</h3>
        <div class="adhoc-panel" id="selected-tables"></div>

        <h3>Available Columns</h3>
        <div class="adhoc-panel list-container" id="columns-list"></div>

        <h3>Selected Columns</h3>
        <div class="adhoc-panel list-container" id="selected-columns"></div>

        <h3>Join Conditions</h3>
        <div class="adhoc-panel list-container" id="join-conditions"></div>
        <button class="btn btn-white btn-sm mb-3" onclick="addJoinCondition()">Add Join Condition</button>

        <h3>Filter Conditions</h3>
        <div class="adhoc-panel list-container" id="filter-conditions"></div>
        <button class="btn btn-white btn-sm" onclick="openFilterDialog()">Add Filter Condition</button>

        <div class="mt-3">
          <button class="btn btn-secondary btn-sm" onclick="openSaveReportDialog()">Save Query</button>
        </div>
      </div>

      <div class="mt-3">
        <label for="limit" class="font-weight-bold">Limit Results:</label>
        <select id="limit" class="form-control d-inline-block w-auto ml-1">
          <option value="100">100</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
          <option value="">No Limit</option>
        </select>
      </div>

      <div class="mt-2">
        <button class="btn btn-primary-light btn-sm" onclick="runQuery()">Run Query</button>
        <button class="btn btn-white btn-sm" onclick="exportFile('csv')">Export CSV</button>
        <button class="btn btn-white btn-sm" onclick="exportFile('xlsx')">Export XLSX</button>
      </div>

      <h3 class="mt-4">Results</h3>
      <div id="results-status" class="preview-note">Add a column to preview the first 15 rows.</div>
      <div id="results-container" class="table-responsive">
        <table class="table table-sm table-striped" id="results-table">
          <thead></thead>
          <tbody></tbody>
        </table>
      </div>

      <div class="modal-backdrop-adhoc" id="filter-modal">
        <div class="adhoc-modal">
          <h3 id="filter-title">Filter Column</h3>
          <label>Column expression</label>
          <input id="filter-column" class="form-control" maxlength="512" placeholder="table.column or table.jsonb_column->>'key'">
          <small>For JSONB, use PostgreSQL path syntax like <code>exammeta-&gt;&gt;'status'</code> or <code>itemmeta-&gt;'field'-&gt;&gt;'value'</code>.</small>
          <label>Operator</label>
          <select id="filter-operator" class="form-control">
            <option value="=">=</option><option value="!=">!=</option><option value=">">&gt;</option><option value="&lt;">&lt;</option><option value=">=">&gt;=</option><option value="&lt;=">&lt;=</option><option value="LIKE">LIKE</option><option value="ILIKE">ILIKE</option><option value="IN">IN</option><option value="IS NULL">IS NULL</option><option value="IS NOT NULL">IS NOT NULL</option>
          </select>
          <label>Sample values</label>
          <select id="filter-samples" class="form-control" multiple size="6"></select>
          <button type="button" class="btn btn-white btn-sm mt-1" onclick="loadSampleValues()">Load Sample Values</button>
          <label>Value / typed values</label>
          <textarea id="filter-value" class="form-control" rows="3" maxlength="2000" placeholder="For IN, separate values with commas or select one or more sample values."></textarea>
          <div class="mt-3 text-right"><button class="btn btn-secondary btn-sm" onclick="saveFilterFromDialog()">Save Filter</button><button class="btn btn-white btn-sm" onclick="closeFilterDialog()">Cancel</button></div>
        </div>
      </div>

      <div class="modal-backdrop-adhoc" id="join-modal">
        <div class="adhoc-modal">
          <h3 id="join-title">Edit Join Condition</h3>
          <label>Join type</label><select id="join-type-dialog" class="form-control"><option value="INNER">INNER</option><option value="LEFT">LEFT</option><option value="RIGHT">RIGHT</option><option value="FULL">FULL</option></select>
          <label>Suggested joins</label><select id="join-suggestions" class="form-control" size="6"></select>
          <button type="button" class="btn btn-white btn-sm mt-1" onclick="loadSuggestedJoins()">Refresh Suggested Joins</button>
          <label>Join condition</label><textarea id="join-condition-dialog" class="form-control" rows="3" maxlength="512" placeholder="users.caveon_id = exams.created_by_id"></textarea>
          <small>Use table aliases for duplicated tables, such as <code>users-1.caveon_id = exams.modified_by_id</code>.</small>
          <div class="mt-3 text-right"><button class="btn btn-secondary btn-sm" onclick="saveJoinFromDialog()">Save Join</button><button class="btn btn-white btn-sm" onclick="closeJoinDialog()">Cancel</button></div>
        </div>
      </div>

      <div class="modal-backdrop-adhoc" id="jsonb-modal"><div class="adhoc-modal"><h3>Choose JSONB Element</h3><p id="jsonb-source"></p><label>Discovered JSON paths</label><select id="jsonb-paths" class="form-control" size="8"></select><button type="button" class="btn btn-white btn-sm mt-1" onclick="loadJsonbPaths()">Refresh JSON Paths</button><label>Or type a dotted path</label><input id="jsonb-custom-path" class="form-control" placeholder="Parent.Child.Value"><div class="mt-3 text-right"><button class="btn btn-secondary btn-sm" onclick="saveJsonbElement()">Add Element Column</button><button class="btn btn-white btn-sm" onclick="closeJsonbDialog()">Cancel</button></div></div></div>
      <div class="modal-backdrop-adhoc" id="save-report-modal"><div class="adhoc-modal"><h3>Save Query</h3><label>Report name</label><input id="save-report-name" class="form-control" maxlength="128" placeholder="My report name"><div class="text-right mt-3"><button type="button" class="btn btn-secondary btn-sm" onclick="saveReport()">Save</button><button type="button" class="btn btn-white btn-sm" onclick="closeSaveReportDialog()">Cancel</button></div></div></div>
      <div class="modal-backdrop-adhoc" id="alias-modal"><div class="adhoc-modal"><h3>Rename Output Column</h3><p id="alias-source"></p><label>Output column name</label><input id="alias-value" class="form-control" maxlength="128" placeholder="Exam Name"><div class="mt-3 text-right"><button class="btn btn-secondary btn-sm" onclick="saveColumnAlias()">Save Name</button><button class="btn btn-white btn-sm" onclick="closeAliasDialog()">Cancel</button></div></div></div>
    </div>
  </b-container>
</template>

<script>
  import { SEI_API_BASE } from '../../utils/constants'
  import { installAdHocReporting } from '../../utils/adhoc-reporting-client'

  export default {
    name: 'OrganizationAdHocReporting',
    props: { org: { type: Object } },
    computed: {
      hasAccess() {
        const perms = this.org?.my_organization_permissions || []
        return !!this.org?.is_premium && (perms.includes('manage_groups') || perms.includes('manage_users'))
      }
    },
    mounted() {
      if (this.hasAccess) {
        installAdHocReporting(this.$refs.adhocRoot, `${SEI_API_BASE}/adhoc_reports`, this.org.id)
      }
    }
  }
</script>

<style scoped>
  .adhoc-panel { border: 1px solid #dee2e6; padding: 0.75rem; min-height: 48px; background: #fff; }
  .list-container { min-height: 100px; }
  .preview-note { color: #6c757d; font-size: 0.9rem; }

  /* Most report-builder rows are inserted by the legacy jQuery builder.
     Deep selectors are required because this component uses scoped CSS. */
  /deep/ .item { cursor: default; padding: 0.4rem 0.5rem; margin: 0.25rem 0; background: #f8f9fa; border: 1px solid #ced4da; display: flex; justify-content: space-between; align-items: center; gap: 10px; }
  /deep/ .item.dragging { opacity: .5; }
  /deep/ .drag-handle { cursor: grab; color: #666; margin-right: 8px; }
  /deep/ .item-main { flex: 1; min-width: 0; }
  /deep/ .action-btn { margin-left: 8px; cursor: pointer; color: var(--primary, #6f4176); font-weight: 600; display: inline-flex; align-items: center; }
  /deep/ .remove-btn { color: #dc3545; }
  /deep/ .filter-btn { width: 20px; height: 20px; justify-content: center; flex: 0 0 20px; }
  /deep/ .filter-btn svg { width: 16px !important; height: 16px !important; max-width: 16px; max-height: 16px; stroke: #333; stroke-width: 2; display: block; }
  /deep/ .filter-btn.unfiltered svg { fill: none; }
  /deep/ .filter-btn.filtered svg { fill: #333; }
  /deep/ #selected-tables .item { border-radius: 3px; background: #fff; border: 1px solid #ced4da; box-shadow: 0 1px 2px rgba(0,0,0,.04); }
  /deep/ .join-condition-input { flex: 1 1 auto; min-width: 420px; max-width: calc(100% - 220px); }
  /deep/ #join-conditions .item { gap: 0.75rem; }
  .join-type { width: 90px; flex: 0 0 90px; }
  .modal-backdrop-adhoc { display: none; position: fixed; inset: 0; background: rgba(0,0,0,.35); z-index: 1040; }
  .adhoc-modal { background: #fff; width: 560px; max-width: 90%; margin: 8% auto; padding: 1.25rem; border: 1px solid #888; box-shadow: 0 4px 16px rgba(0,0,0,.25); }
  .adhoc-modal label { display: block; margin-top: 10px; font-weight: 600; }
  #results-container { max-width: 100%; overflow-x: auto; overflow-y: hidden; display: block; }
  /deep/ #results-table { white-space: nowrap; width: max-content; min-width: 100%; }
</style>
